export const reportsConst = {
  all: 'all',
  whitespots: 'Whitespots',
}
